import React from 'react'
    import HeroSection from '../components/HeroSection'
    import AboutSection from '../components/AboutSection'
    import ServicesSection from '../components/ServicesSection'
    import HowItWorksSection from '../components/HowItWorksSection'
    import FundingApplicationForm from '../components/FundingApplicationForm'
    import ConsultationSection from '../components/ConsultationSection'
    import FAQSection from '../components/FAQSection'

    const HomePage = () => {
      return (
        <div data-component-path="client/src/pages/HomePage.jsx" data-component-line="1:4" data-component-id="client/src/pages/HomePage.jsx:1:4">
          <HeroSection />
          <AboutSection />
          <ServicesSection />
          <HowItWorksSection />
          <FundingApplicationForm />
          <ConsultationSection />
          <FAQSection />
        </div>
      )
    }

    export default HomePage